import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';
import { Collapse } from '@mui/material';
import GameDetailsContent from './Content';
import { useGameReportData } from '@/hooks/gameReport/useGameReportData';
import GameDetailsSkeleton from './Skeleton';
import { useToggle } from '@starsoft/common/hooks';

export default function GameDetails() {
  const { t } = useTranslation('game-report');
  const [open, toggle] = useToggle();
  const { isPending } = useGameReportData();

  if (isPending) {
    return <GameDetailsSkeleton />;
  }

  return (
    <div className={styles.container}>
      <div
        className={`${styles.container__card} ${open ? styles['container__card--open'] : ''}`}
        onClick={toggle}
      >
        <span className={styles.container__card__title}>
          {t('game_details_label')}
        </span>

        <i
          className={`${styles.container__card__chevron} ${open ? styles['container__card__chevron--open'] : ''} fa-solid fa-chevron-right`}
        />
      </div>

      <Collapse in={open}>
        <div className={styles['container__collapse-container']}>
          <GameDetailsContent />
        </div>
      </Collapse>
    </div>
  );
}
